import React, { Component } from "react";
import TablePelayanan from "../pelayananObat/pelayananList";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import API from "../../apiService.js";

export default class pelayanaObat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datas: [],
      filteredDatas: [],
      isLoading: true,
      clinic: [],
      frDate: moment(new Date()).format("YYYY-MM-DD"),
      enDate: moment(new Date()).format("YYYY-MM-DD"),
      keyword: "",
      limit: "10",
      sort: "DESC",
      served: "0",
      puskesmas_id: JSON.parse(localStorage.getItem("puskesmasProfile"))
        ? JSON.parse(localStorage.getItem("puskesmasProfile")).code
        : "",
    };

    this.handleChange = this.handleChange.bind(this);
  }
  checkBoxRef = React.createRef();

  checkHandler = (checked) => {
    if (checked) {
      this.setState(
        {
          served: true,
        },
        () => this.fetchDatas()
      );
    } else {
      this.setState(
        {
          served: false,
        },
        () => this.fetchDatas()
      );
    }
  };

  onChangeKeyword = (e) => {
    const param = e.target.value;
    this.setState((prevState) => ({
      keyword: param, // update the value of specific key
    }));
    // console.log(this.state.keyword);
  };

  // checkHandler = (checked) => {
  //   let { datas } = this.state;
  //   datas = this.prescribesFilter(datas);
  //   if (checked) {
  //     this.setState({
  //       filteredDatas: datas,
  //     });
  //   } else {
  //     this.setState({
  //       filteredDatas: datas,
  //     });
  //   }
  // };

  patientFilter = (datas) => {
    return datas.filter((data) => {
      return data.served === false;
    });
  };

  prescribesFilter = (datas) => {
    return datas.filter((data) => {
      return data.prescribes.length > 0;
    });
  };

  handleChange = (event) => {
    const id = event.target.value;
    this.setState((prevState) => ({
      served: id, // update the value of specific key
    }));
    // console.log(this.state.served);
  };

  componentDidMount() {
    this.fetchDatas();
    this.getClinic();
  }
  getClinic = async () => {
    const res = await API.get(
      "/apm/clinics/read/" + this.state.puskesmas_id + "/2/0"
    );
    if (res.code === 200) {
      this.setState({
        clinic: res.data,
      });
    }
  };
  fetchDatas = async () => {
    // this.checkBoxRef.current.checked = false;
    var param = {
      keyword: this.state.keyword,
      start_date: this.state.frDate,
      end_date: this.state.enDate,
      limit: this.state.limit,
      sort: this.state.sort,
      served: this.state.served,
    };

    const res = await API.post("registration/prescribe/search/v2", param);
    this.setState({
      datas: res.data,
      isLoading: false,
    });
  };

  render() {
    const frDate = moment(this.state.frDate).toDate();
    const enDate = moment(this.state.enDate).toDate();
    const { filteredDatas, isLoading } = this.state;
    const clinics = this.state.clinic.map((clinic) => {
      if (clinic.clinic.child.length > 0) {
        return (
          <optgroup key={clinic.clinic.id} label={clinic.clinic.name}>
            {clinic.clinic.child.map((cl) => {
              return (
                <option key={cl.id} value={cl.clinic_id}>
                  {cl.name}
                </option>
              );
            })}
          </optgroup>
        );
      } else {
        return (
          <option key={clinic.clinic.id} value={clinic.clinic.id}>
            {clinic.clinic.name}
          </option>
        );
      }
    });
    return (
      <div>
        <div className='container-fluid my-3'>
          <div className='card'>
            <div className='card-header border-0'>
              <div className='row'>
                <div className='col-md-2 pt-2'>
                  <h3>Kata Kunci</h3>
                </div>
                <div className='col-md-10'>
                  <input
                    className='form-control'
                    name='katakunci'
                    placeholder='Nama Pasien'
                    type='text'
                    onChange={this.onChangeKeyword}
                  />
                </div>
              </div>
              <div className='row mt-4'>
                <div className='col-md-2 pt-2'>
                  <h3>Status</h3>
                </div>
                <div className='col-md-3'>
                  <select className='form-control' onChange={this.handleChange}>
                    <option value='0'>Belum Dilayani</option>
                    <option value='1'>Sudah Dilayani</option>
                    <option value='2'>Semua Resep</option>
                  </select>
                </div>
                <div className='col'>
                  <span className='h3 mr-4'>Tanggal</span>
                  {/* </div>
                <div className='col'> */}
                  <DatePicker
                    className='form-control'
                    selected={frDate}
                    onChange={(date) =>
                      this.setState({
                        frDate: moment(date).format("YYYY-MM-DD"),
                      })
                    }
                    value={this.frDate}
                    dateFormat='yyyy-MM-dd'
                  />
                  <DatePicker
                    className='form-control'
                    selected={enDate}
                    onChange={(date) =>
                      this.setState({
                        enDate: moment(date).format("YYYY-MM-DD"),
                      })
                    }
                    value={this.enDate}
                    dateFormat='yyyy-MM-dd'
                  />
                </div>
                <div className='col-md-2 text-right'>
                  <button className='btn btn-success' onClick={this.fetchDatas}>
                    CARI DATA
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              <div className='card'>
                <div className='card-header border-0' />
                <TablePelayanan
                  {...this.props}
                  headers={[
                    "No",
                    "No. Resep",
                    "Waktu",
                    "poli",
                    "No MR",
                    "NIK",
                    "Nama",
                    "Sex",
                    "tgl lahir",
                    "Aksi",
                  ]}
                  datas={this.state.datas}
                  isLoading={isLoading}
                  listsPerPage={10}
                  history={this.props.history}
                  keyword={{
                    keyword: this.state.keyword,
                    start_date: this.state.frDate,
                    end_date: this.state.enDate,
                    limit: this.state.limit,
                    sort: this.state.sort,
                    served: this.state.served,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
